// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2ipFR","title":"AfterBackImages_title__i5FBa","images":"AfterBackImages_images__1eVSn"};